import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Modal from '@mui/material/Modal';
import './styles.scss';
import salesHierarchyIcon from '../../images/sales-hierarchy-icon.png';
import modalCloseIcon from '../../images/modal-close-icon.png';
import ExpandedLaborSummary from '../ExpandedLaborSummary';
import ExpandedSalesSummary from '../ExpandedSalesSummary';
import ExpandedInventorySummary from '../ExpandedInventorySummary';
import ExpandedServicesSummary from '../ExpandedServicesSummary/ExpandedServicesSummary';
import ExpandedOmniChannelSummary from '../ExpandedOmniChannelSummary';

const expandedSummaryContainerClassNames = (props) => {
  let topRow = '';
  let content = '';
  if (
    props.ExpandedSalesSummaryComponent &&
    props.ExpandedSalesSummaryComponent === 'true'
  ) {
    topRow = 'expanded-sales-summary-top-row-container';
    content = 'expanded-sales-summary-content-container';
  }
  if (
    props.ExpandedServiceSummaryComponent &&
    props.ExpandedServiceSummaryComponent === 'true'
  ) {
    topRow = 'expanded-service-summary-top-row-container';
    content = 'expanded-service-summary-content-container';
  }
  if (
    props.ExpandedLaborSummaryComponent &&
    props.ExpandedLaborSummaryComponent === 'true'
  ) {
    topRow = 'expanded-labor-summary-top-row-container';
    content = 'expanded-labor-summary-content-container';
  }
  if (
    props.ExpandedOmniChannelComponent &&
    props.ExpandedOmniChannelComponent === 'true'
  ) {
    topRow = 'expanded-omni-channel-summary-top-row-container';
    content = 'expanded-omni-channel-summary-content-container';
  }
  return { topRow, content };
};

const SimpleModal = (props) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [modalTitle, setModalTitle] = useState(props.title);
  const [titleInModal, setTitleInModal] = useState(props.titleInModal);

  const { topRow: ExpandeSummaryTopRowContainer, content: ExpandeSummaryContentContainer } =
    expandedSummaryContainerClassNames(props);

  let modalSummaryTitle = null;
  if (props.ExpandedSalesSummaryComponent === 'true') {
    modalSummaryTitle = titleInModal;
  } else if (props.ExpandedInventorySummaryComponent === 'true') {
    modalSummaryTitle = titleInModal;
  } else if (props.titleInModal) {
    modalSummaryTitle = props.titleInModal;
  }

  const modalBodyRef = useRef(null);

  useEffect(() => {
    if (!open) {
      return undefined;
    }
    const modalBody = modalBodyRef.current;
    if (!modalBody) {
      return undefined;
    }
    const stopModalContentPropagation = (e) => {
      e.stopPropagation();
    };
    modalBody.addEventListener('click', stopModalContentPropagation);
    return () => {
      modalBody.removeEventListener('click', stopModalContentPropagation);
    };
  }, [open]);

  const body = (
    <div ref={modalBodyRef} className="modal-body-container">
      <div className="modal-header-container">
        <button
          type="button"
          aria-label="Close"
          className="modal-close-btn-icon"
          onClick={handleClose}
        >
          <img alt="" src={modalCloseIcon} />
        </button>
        <h1
          className="modal-heading"
          id="simple-modal-title"
          data-testid="simple-modal-title"
        >
          {modalTitle == null ? null : modalTitle}
        </h1>
      </div>
      <div className="modal-content">
        {modalSummaryTitle ? (
          <div className="modal-content-summaryData-title">
            <h1 className="modal-summaryData-title">{modalSummaryTitle}</h1>
          </div>
        ) : null}

        {props.modalContentOther ? (
          <div
            className={`modal-content-data-row ${ExpandeSummaryTopRowContainer}`}
          >
            {props.modalContentOther}
          </div>
        ) : null}

        <div
          className={`modal-content-summaryData-container ${ExpandeSummaryContentContainer}`}
        >
          {props.ExpandedLaborSummaryComponent === 'true' ? (
            <ExpandedLaborSummary
              primaryLocationNumber={props.primaryLocationNumber}
              primaryLocationName={props.primaryLocationName}
              selectedDateMatrix={props.selectedDateMatrix}
              getModalTitle={setModalTitle}
            />
          ) : null}
          {props.ExpandedSalesSummaryComponent === 'true' ? (
            <ExpandedSalesSummary
              primaryLocationNumber={props.primaryLocationNumber}
              primaryLocationName={props.primaryLocationName}
              selectedDateMatrix={props.selectedDateMatrix}
              getModalTitle={setModalTitle}
              getTitleInModal={setTitleInModal}
            />
          ) : null}
          {props.ExpandedInventorySummaryComponent === 'true' ? (
            <ExpandedInventorySummary
              primaryLocationNumber={props.primaryLocationNumber}
              primaryLocationName={props.primaryLocationName}
              selectedDateMatrix={props.selectedDateMatrix}
              getModalTitle={setModalTitle}
              getTitleInModal={setTitleInModal}
            />
          ) : null}
          {props.ExpandedServiceSummaryComponent === 'true' ? (
            <ExpandedServicesSummary
              primaryLocationNumber={props.primaryLocationNumber}
              primaryLocationName={props.primaryLocationName}
              selectedDateMatrix={props.selectedDateMatrix}
              getModalTitle={setModalTitle}
              getTitleInModal={setTitleInModal}
            />
          ) : null}
          {props.ExpandedOmniChannelComponent === 'true' ? (
            <ExpandedOmniChannelSummary
              primaryLocationNumber={props.primaryLocationNumber}
              primaryLocationName={props.primaryLocationName}
              selectedDateMatrix={props.selectedDateMatrix}
              getModalTitle={setModalTitle}
              getTitleInModal={setTitleInModal}
            />
          ) : null}
        </div>
      </div>
    </div>
  );

  return (
    <div className="modal-container">
      <button className="modal-open-btn" type="button" onClick={handleOpen}>
        <img
          alt="open modal"
          className="modal-open-btn-img"
          src={salesHierarchyIcon}
        />
      </button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {body}
      </Modal>
    </div>
  );
};

SimpleModal.propTypes = {
  title: PropTypes.string,
  titleInModal: PropTypes.string,
  ExpandedSalesSummaryComponent: PropTypes.string,
  ExpandedInventorySummaryComponent: PropTypes.string,
  ExpandedServiceSummaryComponent: PropTypes.string,
  ExpandedLaborSummaryComponent: PropTypes.string,
  ExpandedOmniChannelComponent: PropTypes.string,
  primaryLocationNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  primaryLocationName: PropTypes.string,
  selectedDateMatrix: PropTypes.string,
  modalContentOther: PropTypes.node,
};

export default SimpleModal;
